import { jsx as t, jsxs as c } from "react/jsx-runtime";
import { useDatePicker as m } from "./index.es851.js";
import d from "classnames";
import { forwardRef as n } from "react";
import e from "./index.es5870.js";
import { SelectText as p } from "./index.es509.js";
import { UtilityChevronIcon as f } from "./index.es439.js";
const k = n(({ value: r, testId: o, ...a }, s) => {
  const { variant: i } = m(), l = d(
    e.default,
    e.select,
    e["size-default"],
    {
      [e.selected]: !!r
    },
    e["datepicker-selectbox"]
  );
  return /* @__PURE__ */ t(
    "button",
    {
      className: e.container,
      ref: s,
      ...a,
      style: i === "collapsed" ? { width: "100%" } : {},
      children: /* @__PURE__ */ c("div", { className: l, "data-testid": o, children: [
        /* @__PURE__ */ t("div", { className: e.value, children: /* @__PURE__ */ t(p, { variant: "semi-bold", element: "p", color: "primary", children: r }) }),
        /* @__PURE__ */ t("div", { className: e.icon, "data-type": "chevron", children: /* @__PURE__ */ t(f, { outline: "default-gray", type: "bold" }) })
      ] })
    }
  );
});
export {
  k as DatePickerHeaderSelector
};
//# sourceMappingURL=index.es5869.js.map
